import React, {useEffect, useState, useContext, useRef} from 'react';
import {getLocalStorage, setLocalStorage} from './Utils';
import ApplicationContext from './ApplicationContext';
import myNewImage from "../assets/images/new.png";

const NavBar = (props) => {
    const [selection, setSelection] = useState();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeCategory, setActiveKeywordSearch] = useState(null);
    const data = useContext(ApplicationContext);
    const menuRef = useRef(null);

    const [enableSubMenu, setEnableSubMenu] = useState(true);
    const [showFlags, setShowFlags] = useState(true);
    useEffect(() => {
        setShowFlags(props.showFlags === undefined ? true : props.showFlags);
        if (props.enableSubMenu !== undefined) {
            setEnableSubMenu(props.enableSubMenu);
        }
    }, [props.showFlags, props.enableSubMenu]);

    const [categories, setCategories] = useState([]);

    const [choicePairsList, setChoicePairsList] = useState();
    useEffect(() => {
        if (data.choicePairsList) {
            const choicePairsList = Object.entries(data.choicePairsList);	

            const categoryMap = {};
            choicePairsList.forEach(([categoryName, categoryData]) => {
                categoryMap[categoryName] = categoryData;
            });
            setCategories(Object.entries(categoryMap));
        }
        setChoicePairsList(Object.entries(data.choicePairsList));

    }, [data.choicePairsList]);

    useEffect(() => {
        // Pull it from local storage, if it doesn't exist then this is the first time the user ran with this version.
        if(props?.selectionIsCategory) {
            const category = getLocalStorage("CATEGORY");
            if (category) {
                setSelection(category);
            }
            else {
                const keys = Object.keys(data.choicePairsList);
                // console.log("DEBUG:  NavBar", keys[0])
                setLocalStorage("CATEGORY", keys[0]);
                setSelection(keys[0]);
            }
        }
        else {
            const savedKeyword = getLocalStorage("KEYWORD_SEARCH");
            if (savedKeyword !== "") {
                setSelection(savedKeyword);
            }
            else {
                // Then just grab the first one from the first keyword search entry and default it to that.
                if (data.choicePairsList) {
                    const keys = Object.keys(data.choicePairsList);
                    const entries = data.choicePairsList[keys[0]];
                    setSelection(entries[0]?.KEYWORD_SEARCH);
                    setLocalStorage("KEYWORD_SEARCH", entries[0]?.KEYWORD_SEARCH);
                }
            }
        }
    }, [props?.selectionIsCategory, data.choicePairsList, choicePairsList]);

    const toggleMenu = (e) => {
        e.preventDefault();
        setIsMenuOpen(!isMenuOpen);
        if (!isMenuOpen) {
            setActiveKeywordSearch(null);
        }
    };

    const handleCategoryClick = (category, e) => {
        e.stopPropagation();
        
        // console.log("DEBUG: props?.selectionIsCategory = ", props?.selectionIsCategory);
        if(props?.selectionIsCategory) {
            setIsMenuOpen(!isMenuOpen);
            setSelection(category);
            setLocalStorage("CATEGORY", category);
        }

        if (enableSubMenu) {
            setActiveKeywordSearch(activeCategory === category ? null : category);
        }

        // console.log("HERE TOP")
        if (props.handleCategoryClick) {
            // console.log("HERE TOP INSIDE")
            props.handleCategoryClick(category);
        }
    };

    const handleItemClick = (keyword, e) => {
        e.stopPropagation();
        if(!props?.selectionIsCategory) {
            setSelection(keyword);
        }
        setIsMenuOpen(false);
        setActiveKeywordSearch(null);
        setLocalStorage("KEYWORD_SEARCH", keyword);
        
        if (props.onClick) {
            // props.onClick({keyword, label: keyword});
            props.onClick(keyword);
        }
    };

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
                setActiveKeywordSearch(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="navbar" ref={menuRef}>
            <ul>
                <li onClick={toggleMenu}>
                    <div>{selection || "Select a Category"}</div>
                    <div>(tap here to change)</div>
                    {isMenuOpen && (
                        <ul className="main-menu">
                            {categories.map(([categoryName, categoryItems]) => (
                                <li 
                                    key={categoryName}
                                    className={`category-item ${activeCategory === categoryName ? 'active' : ''}`}
                                    onClick={(e) => handleCategoryClick(categoryName, e)}
                                >
                                    <span className="category-label">
                                        {categoryName}
                                        {categoryItems.some(item => item.new === "1") && (
                                            showFlags ? <img src={myNewImage} alt="" width={34} /> : <></>
                                        )}
                                    </span>
                                    
                                    {activeCategory === categoryName && (
                                        <ul className="submenu">
                                            {categoryItems.map((item) => (
                                                <li 
                                                    key={item.KEYWORD_SEARCH}
                                                    onClick={(e) => handleItemClick(item.KEYWORD_SEARCH, e)}
                                                    style={{
                                                        opacity: item.monetized === "1" ? 0.5 : 1,
                                                        backgroundColor: item.backgroundColor || '#fff',
                                                        color: item.foregroundColor || '#000'
                                                    }}
                                                >
                                                    {item.KEYWORD_SEARCH}
                                                    {item.new === "1" && (
                                                        showFlags ? <img src={myNewImage} alt="" width={34} /> : <></>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </li>
            </ul>
        </div>
    );
}

export default NavBar;